module.exports = __webpack_public_path__ + "static/media/valikko_palvelut.a8c4cd34.jpg";